<button [type]="type"
        class="btn"
        [ngClass]="getClasses()"
        [disabled]="getDisabled()">
    @if (icon) {
        <i class="vhvicon vhv{{icon}}"></i>
    }
    <ng-content></ng-content>
</button>
